import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";

@Entity('adds')
export class AddsEntity {
  
  @PrimaryGeneratedColumn("increment",{name:'id'})
  Id:number; 
  @Column("varchar",{
    nullable: false,
    length:500,
    name:"image_path"
  })
  imagePath:string;
  @Column("varchar",{
    nullable: false,
    length:500,
    name:"redirect_url"
  })
  redirectUrl:string;
  @Column("varchar",{
    nullable: false,
    length:500,
    name:"location"
  })
  location:string;
  @Column("boolean",{
    nullable:false,
    default:true,               
    name:"status"
  })
  status:boolean;
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;
  @Column("int", {
    nullable: true,
    name: "created_user"
  })
  createdUser: number | null;
  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;
  @Column("int", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: number | null;
  @VersionColumn({
    default:1,
    name: "version_flag"
  })
  versionFlag: number;

 
}